var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"au-auction"},[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Cuộc đấu giá đang diễn ra","active":""}},[_c('auHappenning')],1),_c('b-tab',{attrs:{"title":"Cuộc đấu giá sắp diễn ra"}},[_c('auDelivery')],1),_c('b-tab',{attrs:{"title":"Cuộc đấu giá đã kết thúc"}},[_c('auFinished')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }